// --- Core ---
import {FormattedMessage} from "react-intl";
// --- Material UI ---
import {Typography} from "@mui/material";
import {ReactElement} from "react";

type SubmitErrorKey = "entity too large" | "forbidden" | "network error" | "route not found" | "unauthorized";

const mapErrorRequestStatus = (status: number): SubmitErrorKey => {
  switch (status) {
    case 401:
      return "unauthorized";
    case 403:
      return "forbidden";
    case 404:
      return "route not found";
    case 413:
      return "entity too large";
    default:
      return "network error";
  }
};

const SubmitError = ({submitError}: {submitError: SubmitErrorKey}) => {
  let content: ReactElement = <>{submitError}</>;

  switch (submitError) {
    case "entity too large":
      content = <FormattedMessage id="submitError.entityTooLarge" defaultMessage="The upload is too large and denied by the server"/>;
      break;
    case "forbidden":
      content = <FormattedMessage id="submitError.forbidden" defaultMessage="Access to the resource is forbidden"/>;
      break;
    case "network error":
      content =
        <FormattedMessage id="submitError.network" defaultMessage="There was a network error while submitting the form. Please try again later"/>;
      break;
    case "route not found":
      content = (
        <FormattedMessage
          id="submitError.notFound"
          defaultMessage="The resource was not found while submitting the form. Please make sure it exists"
        />
      );
      break;
    case 'unauthorized':
      content = <FormattedMessage id="submitError.unauthorized" defaultMessage="Access is unauthorized. Make sure you have the correct permissions"/>;
      break;
    default:
      break;
  }

  return <Typography sx={{color: 'error.main'}}>{content}</Typography>;
};

export {
  mapErrorRequestStatus,
  SubmitError,
  SubmitErrorKey
};
